export const nav = {
  services: 'Services',
  analyse: 'Analysis',
  booking: 'Booking',
  pricing: 'Pricing',
  contact: 'Contact'
};

export const hero = {
  title1: 'Websites, Apps',
  title2: 'and IT Solutions for Your Business',
  subtitle: 'We help you from idea to launch – websites, mobile apps, web applications and IT support, delivered with quality and reliability.',
  feature1: 'Strong expertise in web development, app development and IT support for results-driven solutions.',
  feature2: 'From idea and concept development to design, programming and launch – we make the process smooth.',
  btnBooking: 'Booking',
  btnContact: 'Contact Us'
};

export const whyChoose = {
  title: 'Why Choose Us as Your Partner?',
  quality: 'High Quality',
  qualityDesc: 'Dedicated to delivering high-quality solutions – whether websites, apps or IT support – that meet or exceed your expectations, always on time.',
  communication: 'Clear Communication',
  communicationDesc: 'Close dialogue throughout the process with quick responses and understandable explanations without technical jargon.',
  solutions: 'Tailored Solutions',
  solutionsDesc: 'Every project is unique. We create customized websites, apps and IT solutions based on your specific needs and business goals.'
};

export const services = {
  title: 'Services We Offer',
  service1Title: 'Website Development',
  service1Desc: 'Responsive and attractive websites for your business. Custom designs that convert visitors into customers.',
  service2Title: 'App & Web Application Development',
  service2Desc: 'We develop mobile apps and web applications tailored to your needs – from simple tools to complex systems for iOS, Android and browser.',
  service3Title: 'IT Help & Support',
  service3Desc: 'Practical IT help for businesses – troubleshooting, system setup, user support and technical consulting. We are available when you need us.',
  service4Title: 'SEO Optimization',
  service4Desc: 'Increase visibility and organic traffic on Google. We optimize your website to rank higher in search results.',
  service5Title: 'Maintenance & Operations',
  service5Desc: 'Updates, security and technical support for websites and applications. We keep your solutions running 24/7.',
  seeDetails: 'See details',
  btnAll: 'See All Services'
};

export const process = {
  title: 'The Path to Your New Solution',
  subtitle: 'Simple and straightforward process from start to finish – whether it\'s a website, app or IT project',
  step1: 'Initial Consultation',
  step1Desc: 'We get to know each other and discuss your needs, goals and vision for the project.',
  step2: 'Planning & Design',
  step2Desc: 'You receive design proposals and a technical plan based on your preferences and requirements.',
  step3: 'Development',
  step3Desc: 'Our team builds your solution with clean code, good architecture and SEO optimization.',
  step4: 'Review & Feedback',
  step4Desc: 'You review the first version and provide feedback for adjustments.',
  step5: 'Quality Assurance',
  step5Desc: 'Final testing on all devices and browsers to ensure perfection.',
  step6: 'Launch & Support',
  step6Desc: 'Your solution goes live with ongoing support, maintenance and IT help.'
};

export const features = {
  title: 'Everything Included',
  feature1: 'Complete Website',
  feature2: 'Hosting',
  feature3: 'SEO Optimized',
  feature4: 'Modern Design',
  feature5: 'Mobile Friendly',
  feature6: 'SSL Security',
  feature7: 'App Development',
  feature8: 'IT Help & Support'
};

export const pricing = {
  title: 'Pricing',
  subtitle: 'Choose the package that fits your needs',
  basis: 'Basic',
  standard: 'Standard',
  premium: 'Premium',
  perMonth: '/ month',
  setupFee: '+ {{amount}} setup fee',
  feature1: 'Up to {{pages}} pages',
  feature2: 'Responsive design',
  feature3: '{{updates}} yearly updates',
  feature4Basis: 'SEO optimization',
  feature4Standard: 'Advanced SEO',
  feature4Premium: 'Premium SEO & Analytics',
  feature5: 'SSL certificate',
  feature6Basis: 'Basic support',
  feature6Standard: 'Priority support',
  feature6Premium: 'Dedicated 24/7 support',
  feature7Premium: 'Advanced features',
  basisDesc: 'Perfect for small businesses starting out.',
  standardDesc: 'Ideal for growing businesses with more needs.',
  premiumDesc: 'For businesses that demand the best.',
  mostPopular: 'Most Popular',
  disclaimer: 'All prices include VAT. 12-month commitment with 30 days notice thereafter. App and IT projects are priced separately based on requirements.'
};

export const cta = {
  title: 'Ready to Start Your Next Project?',
  subtitle: 'Whether you need a website, an app or IT help – let us create a digital solution that delivers results for your business.',
  btn: 'Book a Consultation'
};

export const faq = {
  title: 'Frequently Asked Questions',
  q1: 'How long does it take to build a website?',
  a1: 'Usually 5 - 10 days from project start to launch, depending on complexity and scope. We can adapt faster timelines if needed.',
  q2: 'What is included in the monthly price?',
  a2: 'Hosting, SSL certificate, security updates, backup, technical support and a number of content updates per year based on your package.',
  q3: 'Do you help with domain registration?',
  a3: 'Domain is purchased separately as prices vary. We can guide you through the process or handle it for you.',
  q4: 'What happens after the website is launched?',
  a4: 'We offer ongoing support and maintenance. You can contact us anytime for help, and we ensure your website remains secure and updated.'
};

export const support = {
  title: 'We Are Here to Help',
  subtitle: 'Multiple ways to get in touch with us',
  email: {
    title: 'Email Support',
    description: 'Send us an email anytime, we respond within 24 hours',
    action: 'Send Email',
  },
  phone: {
    title: 'Phone Support',
    description: 'Call us for immediate help with websites, apps or IT questions',
    action: 'Call Now',
  },
  ai: {
    title: 'AI Assistant',
    description: 'Get instant answers to your questions 24/7',
    action: 'Chat Now',
  },
};

export const contactForm = {
  title: 'Contact Us',
  subtitle: 'Fill out the form below and we will get in touch with you as soon as possible.',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  phone: 'Phone Number',
  business: 'Business',
  message: 'Message',
  maxChars: 'Maximum 500 characters',
  btnSubmit: 'Send Message',
  btnSending: 'Sending...',
  placeholderFirstName: 'Your first name',
  placeholderLastName: 'Your last name',
  placeholderEmail: 'your@email.com',
  placeholderPhone: '+47 123 45 678',
  placeholderBusiness: 'Your company name',
  placeholderMessage: 'Tell us about your project – website, app, IT help or something else...',
  successMessage: 'Thank you for your inquiry! We will contact you soon.',
  errorMessage: 'Something went wrong. Please try again.',
  validationError: 'Please fill out all fields',
  emailError: 'Please provide a valid email address',
  lengthError: 'Message cannot exceed 500 characters'
};

export const footer = {
  description: 'Norwegian IT company focused on web development, app development and IT help. From idea to launch with quality and reliability.',
  servicesTitle: 'Services',
  service1: 'Website Development',
  service2: 'App Development',
  service3: 'IT Help & Support',
  service4: 'SEO Optimization',
  companyTitle: 'Company',
  aboutUs: 'About Us',
  projects: 'Our Projects',
  contact: 'Contact',
  contactTitle: 'Contact',
  copyright: '© 2025 NorWeb AS. All rights reserved.'
};

export const booking = {
  title: 'Book a Consultation',
  subtitle: 'Choose a time that works for you, and we\'ll have a no-obligation chat about your project – whether it\'s a website, app or IT help.',
  backHome: 'Back to Home',
  duration: '15 Minutes',
  durationDesc: 'We take our time to understand your needs and goals.',
  format: 'Video or Phone',
  formatDesc: 'Choose the format that suits you best.',
  preparation: 'No Preparation',
  preparationDesc: 'Come as you are - we\'ll guide you through the conversation.'
};

export const chatbot = {
  title: 'AI Assistant',
  subtitle: 'Online now',
  openChat: 'Open chat',
  closeChat: 'Close chat',
  inputPlaceholder: 'Type your message...',
  sendMessage: 'Send message',
  welcomeMessage: 'Hi! 👋 I\'m your AI assistant. I can answer questions about our services in web development, app development and IT support, as well as pricing, process and more. How can I help you today?',
  answerPricing: 'We offer three packages for websites:\n\n📦 Basic: NOK 990/month + 4,490 setup\n- Up to 5 pages\n- 2 annual updates\n- SEO optimization\n- Basic support\n\n📦 Standard: NOK 1,490/month + 4,490 setup (Most popular)\n- Up to 10 pages\n- 4 annual updates\n- Advanced SEO\n- Priority support\n\n📦 Premium: NOK 2,490/month + 4,490 setup\n- Up to 20 pages\n- 12 annual updates\n- Full SEO package\n- Dedicated support\n- Custom design\n\nApp development and IT help are priced separately based on requirements. Contact us for a no-obligation quote!\n\nAll prices include hosting, SSL and VAT.',
  answerServices: 'We offer the following services:\n\n🌐 Website Development - Responsive and attractive websites tailored to your business\n\n📱 App Development - Mobile apps and web applications for iOS, Android and browser\n\n💻 IT Help & Support - Troubleshooting, system setup, user support and technical consulting\n\n🔍 SEO Optimization - Increase visibility and organic traffic on Google\n\n🛠️ Maintenance & Operations - Updates, security and technical support 24/7\n\nWould you like to know more about a specific service?',
  answerTimeline: 'Typically it takes 5-10 days from project start to launch for websites, depending on complexity and scope.\n\nFor app development, the timeline varies more based on functionality and platform.\n\nThe process includes:\n1. Initial consultation\n2. Planning & design\n3. Development\n4. Review & feedback\n5. Quality assurance\n6. Launch & support\n\nWe can adjust faster timelines if needed. Would you like to book a consultation to discuss your project?',
  answerProcess: 'Our process is simple and straightforward:\n\n1️⃣ Initial Consultation - We get to know each other and discuss your needs and vision\n\n2️⃣ Planning & Design - You receive design proposals and a technical plan\n\n3️⃣ Development - We build the solution with clean code and good architecture\n\n4️⃣ Review & Feedback - You review and provide feedback\n\n5️⃣ Quality Assurance - Testing on all devices and browsers\n\n6️⃣ Launch & Support - The solution goes live with ongoing support\n\nWe keep you updated throughout the process!',
  answerContact: 'You can contact us in the following ways:\n\n📧 Email: kontakt@norwebas.no\nWe respond within 24 hours\n\n📞 Phone: +47 94 12 19 09\nMon-Fri: 08:30 - 16:30\n\n📍 Location: Hamar, Norway\n\n📅 Or book a free consultation directly in our calendar!\n\nWhat works best for you?',
  answerSEO: 'SEO (search engine optimization) is included in all our website packages!\n\n🔍 Basic: SEO optimization\n- Basic on-page SEO\n- Meta tags and descriptions\n- Mobile-friendly design\n\n🔍 Standard: Advanced SEO\n- Everything from Basic\n- Keyword research\n- Structured data\n- Performance optimization\n\n🔍 Premium: Full SEO package\n- Everything from Standard\n- Comprehensive keyword strategy\n- Monthly SEO reporting\n- Continuous optimization\n\nWe ensure your website ranks higher on Google!',
  answerSupport: 'We offer comprehensive support and maintenance:\n\n✅ Hosting included\n✅ SSL certificate\n✅ Security updates\n✅ Backup\n✅ Technical support\n✅ Content updates (based on package)\n✅ IT help when needed\n\nSupport level:\n📦 Basic: Basic support\n📦 Standard: Priority support\n📦 Premium: Dedicated support\n\nWe keep your solutions secure, updated and running 24/7. You can contact us anytime!',
  answerBooking: 'Great! You can easily book a free consultation:\n\n📅 Click the "Book a Consultation" button on the website\n⏰ Choose a time that suits you\n💬 We\'ll have a no-obligation chat about your project – website, app or IT help\n\nThe consultation lasts about 15 minutes and can be done via video or phone.\n\nNo preparation needed - we guide you through the conversation!\n\nWould you like me to help you find the booking button?',
  answerDefault: 'Thanks for your question! I can help you with information about:\n\n💰 Pricing and packages\n🛠️ Services we offer (websites, apps, IT help)\n⏱️ Timelines and delivery\n📋 Our work process\n📞 Contact information\n🔍 SEO and optimization\n🤝 Support and maintenance\n📅 Booking a consultation\n\nWhat would you like to know more about?'
};

export const analyse = {
  skipToMain: 'Skip to main content',
  mainNav: 'Main navigation',
  logoAria: 'NorWeb AS - Go to homepage',
  contactBtn: 'Contact Us',
  hero: {
    title: 'See what\'s costing you customers',
    subtitle: 'Get a free and instant analysis of your website – in seconds.',
    inputLabel: 'Enter your domain',
    placeholder: 'Enter your domain (e.g. yourcompany.com)',
    ctaButton: 'Analyze My Website',
    analyzing: 'Analyzing...',
    privacy: 'No login required. Completely free and no obligation.',
    feature1Title: 'Instant Analysis',
    feature1Desc: 'Get results in seconds',
    feature2Title: '100% Free',
    feature2Desc: 'No hidden costs',
    feature3Title: 'Professional Report',
    feature3Desc: 'Detailed insights and recommendations'
  },
  results: {
    title: 'Analysis Results',
    downloadPDF: 'Download PDF',
    verifiedBadge: 'Verified Website',
    modernStandardsBadge: 'Built with Modern Standards',
    // Standard domain score labels
    scoreExcellent: 'Strong Performance',
    scoreGood: 'Moderate Improvement Potential',
    scoreFair: 'Improvement Potential',
    scorePoor: 'Needs Significant Improvement',
    // Preferred domain score labels
    scoreExcellentPreferred: 'Strong Performance',
    scoreGoodPreferred: 'Solid Performance',
    scoreFairPreferred: 'Improvement Potential',
    // Standard domain summaries
    summaryExcellent: 'Your website performs well! There is still room for small improvements that can further increase conversions.',
    summaryGood: 'Your website has a solid foundation, but there are several areas that can be improved to increase visibility and conversions.',
    summaryPoor: 'Your website has significant improvement potential. Several technical and strategic factors negatively affect both visibility and conversions.',
    // Preferred domain summaries
    summaryExcellentPreferred: 'Your website has a solid foundation with excellent performance. Small optimizations can provide further improvements.',
    summaryGoodPreferred: 'Your website has a solid foundation with some optimization opportunities.',
    summaryFairPreferred: 'Your website has a good foundation with some areas that can be optimized for even better results.',
    metrics: {
      pageSpeed: 'Speed',
      mobileResponsive: 'Mobile Friendly',
      seo: 'SEO',
      security: 'Security',
      accessibility: 'Accessibility',
      design: 'Design',
      cta: 'CTA Visibility',
      trustSignals: 'Trust Signals'
    },
    // Standard domain issue title
    issuesTitle: 'Critical Improvement Areas',
    // Preferred domain issue title
    issuesTitlePreferred: 'Optimization Opportunities',
    impact: 'Business Impact',
    whyItMatters: 'Why This Matters',
    ctaTitle: 'Ready to improve your website?',
    ctaDescription: 'Let us help you solve these problems and create a website that converts visitors into customers.',
    ctaPrimary: 'Book a Free Strategy Call',
    ctaSecondary: 'See Our Services'
  },
  revenue: {
    title: 'Estimated Revenue Potential',
    titlePreferred: 'Optimization Potential',
    subtitle: 'Small improvements can deliver big results for your business',
    subtitlePreferred: 'Fine-tuning can provide further improvements',
    conversionIncrease: 'Conversion rate increase',
    conversionIncreasePreferred: 'Potential conversion increase',
    conversionDesc: 'Can mean significant revenue growth',
    conversionDescPreferred: 'With further optimization',
    trafficIncrease: 'More organic traffic',
    trafficDesc: 'With better SEO and performance',
    trafficDescPreferred: 'With fine-tuned SEO',
    revenueIncrease: 'Increased revenue',
    revenueDesc: 'Through optimization',
    revenueDescPreferred: 'Through fine-tuning',
    example: 'If your website has 1,000 visitors per month and we increase the conversion rate by just 1%, it can mean significant increased revenue. With better SEO, we can double your traffic, and with optimized design and structure, we can increase conversions by up to 40%. These aren\'t just numbers – this is real growth for your business.',
    examplePreferred: 'Your website already has a good foundation. With targeted optimizations, we can fine-tune performance further. Even small improvements of 0.5-1.5% in conversion rate can provide noticeable growth over time.'
  },
  whyHappens: {
    title: 'Why Does This Happen?',
    titlePreferred: 'Areas for Optimization',
    reason1Title: 'No conversion strategy',
    reason1Desc: 'The website is not built with conversion as the main goal. Design and structure lack strategic focus on turning visitors into customers.',
    reason2Title: 'Lack of UX optimization',
    reason2Desc: 'The user experience is not optimized. Visitors don\'t find what they\'re looking for quickly enough, or the process is too complicated.',
    reason3Title: 'No technical performance optimization',
    reason3Desc: 'Slow loading, poor mobile experience, and technical issues cause visitors to leave before they convert.',
    reason4Title: 'Weak SEO foundation',
    reason4Desc: 'The website doesn\'t rank high enough on Google. Potential customers find your competitors instead of you.',
    reason5Title: 'Not adapted to modern buying behavior',
    reason5Desc: 'Today\'s customers expect quick information, clear calls-to-action, and a seamless experience across all devices.'
  },
  whyChooseUs: {
    title: 'Why Choose Us?',
    subtitle: 'We don\'t just build websites – we build digital sales tools that deliver results',
    benefit1Title: 'Conversion-Focused Websites',
    benefit1Desc: 'We design and build with one goal: to turn visitors into paying customers.',
    benefit2Title: 'Speed & SEO Optimization',
    benefit2Desc: 'Fast loading times and top SEO practices ensure you rank high and retain visitors.',
    benefit3Title: 'Mobile-First Design',
    benefit3Desc: 'Over 60% of traffic comes from mobile. We ensure perfect experience on all devices.',
    benefit4Title: 'Clear Conversion Structure',
    benefit4Desc: 'Strategically placed CTAs, trust signals, and user journeys that lead to action.',
    benefit5Title: 'Measurable ROI',
    benefit5Desc: 'We focus on results you can measure: more traffic, more leads, increased revenue.',
    benefit6Title: 'Ongoing Support & Optimization',
    benefit6Desc: 'We\'re with you all the way – from launch to continuous improvement and growth.',
    ctaPrimary: 'Book a Free Strategy Call',
    ctaSecondary: 'Get a Custom Quote'
  },
  error: {
    failed: 'Could not analyze the website. Please check the domain and try again.'
  }
};

export const analyseSection = {
  title: 'Free Website Analysis',
  subtitle: 'Find out what\'s holding your website back',
  description: 'Our free analysis gives you insights into how your website performs in key areas such as speed, SEO, mobile-friendliness, and security. In seconds, you get a detailed report with concrete improvement suggestions that show how we can make your website better.',
  feature1: 'Instant results',
  feature2: 'No obligations',
  feature3: 'Detailed report',
  btn: 'Analyze now'
};
